import styled from 'styled-components';

import theme from '@theme';

export const CardLink = styled.a`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Card = styled.div`
  border: 1px solid gray;
  width: 100%;

  ${theme.mediaQueries.LARGE_1X_UP} {
    max-width: 450px;
    width: 100%;
  }

  &:hover {
    .campainCard__image {
      transform: scale(1.1);
    }

    .campaignCard__title {
      color: ${theme.palette.primaryBrand};
    }
  }

  .campaignCard__title {
    transition: color 0.3s ease;
  }
`;

export const CardImageWrapper = styled.div`
  position: relative;
`;

export const CardImageInnerWrapper = styled.div`
  overflow: hidden;
`;

export const ExpirationDateWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: -6px;
  background-image: url('/static/images/empty-popper-ico.svg');
  width: 100px;
  height: 46px;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGray};
`;

export const BottomRightImageWrapper = styled.div<{
  backgroundImageUrl: string;
}>`
  position: absolute;
  bottom: 20px;
  right: -6px;
  background-image: url(${({ backgroundImageUrl }) => backgroundImageUrl});
  width: 100px;
  height: 46px;
`;

export const StyledTypography = styled.h3`
  --line-height: 18px;
  --line-clamp: 3;
  font-size: 12px;
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: var(--line-clamp);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${theme.palette.lightBlack};
  opacity: 0.8;
  line-height: var(--line-height);
  height: calc(var(--line-height) * var(--line-clamp));
`;

type ImgObjProps = {
  backgroundImageUrl: string;
};

export const CardMedia = styled.div<ImgObjProps>`
  width: 100%;
  aspect-ratio: 1 / 1;
  background-image: url(${({ backgroundImageUrl }) => backgroundImageUrl});
  background-size: cover;
  -webkit-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
`;

export const CardContent = styled.div<{ hasDescription?: boolean }>`
  padding: 16px;
  height: ${({ hasDescription }) => (hasDescription ? '120px' : '70px')};
`;

export const CardTitle = styled.h1`
  --line-height: 24px;
  --line-clamp: 2;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: var(--line-clamp);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: var(--line-height);
  height: calc(var(--line-height) * var(--line-clamp));
`;
